import {configureStore} from '@reduxjs/toolkit';
import cartReducer from './feature/cart-slice'
import peraturanReducer from './feature/peraturan-slice'
import peraturanEksReducer from './feature/peraturaneks-slice'
import peraturansmReducer from './feature/peraturan-sm-slice'
import checklistReducer from './feature/checklist-slice'
import pendapatReducer from './feature/pendapat-slice'
import dokumenReducer from './feature/document-slice'
import putusanHukumReducer from './feature/putusan-hukum-slice'
import pagChecklist from './feature/paginate-checklist-slice'
import pagPendapat from './feature/paginate-pendapat-slice'
import pagDokumen from './feature/paginate-document-slice'
import pagPutusan from './feature/paginate-putusan-hukum-slice'
import karyaReducer from './feature/karya-slice'
import authReducer from './feature/auth-slice'
import pagPeraturanReducer from './feature/paginate-slice'
import pagPeraturanEksReducer from './feature/paginateks-slice'
import pagPeraturanSmReducer from './feature/paginate-sm-slice'
import bumnPaginate from './feature/bumn-paginate'
import bumnReducer from './feature/bumn-slice'
import karyaPaginate from './feature/karya-paginate'
import putusanReducer from './feature/putusan-slice'
import paginatePutusan from './feature/pag-putusan-slice'
import categoryReducer from './feature/category-slice'
import bidangreducer from './feature/bidang-slice'
import bidangdokumenreducer from './feature/bidang-dokumen-slice'
import picReducer from './feature/pic-slice'
import menuReducer from './feature/menu-slice'
import undangReducer from './feature/undang-slice '
import undanganPeReducer from './feature/undangan-store-slice'
import anggaranReducer from './feature/anggaran-paginate '
import anggaranStoreReducer from './feature/anggaran-slice'
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const store  = configureStore({
    reducer:{
        cartReducer,
        authReducer,
        peraturanReducer,
        peraturansmReducer,
        pagPeraturanReducer,
        pagPeraturanSmReducer,
        putusanReducer,
        paginatePutusan,
        karyaPaginate,
        karyaReducer,
        bumnPaginate,
        bumnReducer,
        categoryReducer,
        checklistReducer,
        pagChecklist,
        pagPendapat,
        pendapatReducer,
        putusanHukumReducer,
        pagPutusan,
        dokumenReducer,
        pagDokumen,
        picReducer,
        menuReducer,
        undangReducer,
        undanganPeReducer,
        anggaranReducer,
        anggaranStoreReducer,
        peraturanEksReducer,
        bidangreducer,
        bidangdokumenreducer,
        pagPeraturanEksReducer
        
    }
})

export type RootState= ReturnType<typeof store.getState>
export type AppDispatch= typeof store.dispatch 
export const useAppSelector:TypedUseSelectorHook<RootState> = useSelector